import { Row } from "reactstrap";
import CrediCardIcon from "../../assets/CrediCardIcon";
import FactoryIcon from "../../assets/FactoryIcon";
import GraphIcon from "../../assets/GraphIcon";
import PersonListIcon from "../../assets/PersonListIcon";
import SecurityPink from "../../assets/SecurityPink";
import ThumbGreen from "../../assets/ThumbGreen";
import ButtonCommon from "../../components/ButtonCommon";
import Cards from "../../components/Cards";
import HeadingMain from "../../components/Heading";
import './index.scss'
import { logout } from '../../api/onboarding';
import { SSO_auth_path } from '../../config';

const InfoSection = () => {

    let array = [
        {
            icon: <ThumbGreen />,
            title: 'Improve your Compliance history',
            des: 'Your compliance history matters more than you know.  Potential customers and lenders  keep an eye on  untimely GST payments',
        },
        {
            icon: <FactoryIcon />,
            title: 'Invest available cash in business',
            des: 'GST Payments can feel untimely when you may have an urgent purchase order or a customer order to rather work on',
        },
        {
            icon: <PersonListIcon />,
            title: 'Recommended by CAs & Experts',
            des: 'More than 100+ Tax Experts have partnered with ClearTax to help their clients grow with credit for their GST payments',
        }, {
            icon: <GraphIcon />,
            title: 'No Usage, <br /> No Interest',
            des: 'You pay only what you use. Interest is charged only on the amount utilised to pay taxes.',
        }, {
            icon: <SecurityPink />,
            title: 'Collateral free',
            des: 'Be rest assured. We don’t ask for any collaterals for activating the credit line.',
        }, {
            icon: <CrediCardIcon />,
            title: 'Credit limit valid <br />for 1 year',
            des: 'Valid for 1 year -  Once your credit line is activated, it is valid for one year',
        },
    ]


  const renderCards = () => {
    return array.map((val, index) => {
      return(
        <Cards  
          key={index}
          icon={val.icon}
          title={val.title}
          des={val.des}
        />
      )
    })
  }

  const applyNow = () => {
    let stingToConvert = '/verification'
    const urlParams = new URLSearchParams(window.location.search);
    const partnerToken = urlParams.get('token');
    if (partnerToken) {
      stingToConvert += '?token='+partnerToken;
    }
    let redirectUrl = btoa(stingToConvert)
    //logout();

    window.location.href = `${SSO_auth_path}&return_path=${redirectUrl}`;
  }

	return (
    <section className="mainContent">
      <div className="infoContainer">
        <HeadingMain text="Why GST PayLater?" />
        <Row>
          {renderCards()}
        </Row>
        <div className="buttonOut">
          <ButtonCommon title="Check Eligibility" onClick={() => applyNow()}/>
        </div>
      </div>
		</section>
	)
}

export default InfoSection;